<div class="header" [class.disabled]="disabled" [ngClass]="color" >
  <h3>{{title}}</h3>
</div>
<div class="content">
  <ng-content></ng-content>
</div>
